import { Linking, StyleSheet, Text } from "react-native";

import { API_URL } from "../env";
import { colors, fonts } from "../theme";
import { Button, Card } from "./brand";

// Free PDF report download for AU-08 (Private Health) and AU-06 (HECS/HELP).
// Per the monetisation plan (docs/business-plan.md v2) these reports are free —
// the calculator is the trust funnel and a paywall in front of it is
// net-negative. The route is owner-gated; the buyer needs no account beyond the
// result's unguessable id. Information-only copy (validation §3): it's "your
// numbers + how they're worked out", never a product pick or advice.
export function FreePdfCard({
  id,
  product,
}: {
  id: string;
  product: "au08" | "au06";
}): JSX.Element {
  const url = `${API_URL}/pdf/${product}/${id}`;
  return (
    <Card tone="sand">
      <Text style={styles.title}>Take your numbers with you — free</Text>
      <Text style={styles.muted}>
        A few pages with the figures you just saw, how each one is worked out,
        and where to check the rules yourself. No product picks, no advice — just
        the facts, free.
      </Text>
      <Button
        label="Download the PDF"
        testID="pdf-download"
        onPress={() => void Linking.openURL(url)}
      />
    </Card>
  );
}

const styles = StyleSheet.create({
  title: { fontFamily: fonts.display, fontSize: 18, color: colors.ink },
  muted: { fontFamily: fonts.body, fontSize: 14, lineHeight: 20, color: colors.inkSoft },
});
